// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___ee1Ly","wasteAccompanyingDocumentContainer":"wasteAccompanyingDocumentContainer___uKZ0y"};